import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  connect() {
    useClickOutside(this)
  }

  show() {
    this.element.classList.toggle("is-active")
  }

  clickOutside(event) {
    this.element.classList.remove("is-active")
  }
}